package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class UpsertEpisodeTranslationRequest(
    val title: String? = null,
    val description: String? = null
)
